exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-number[data-v-61dd14d0]{display:block;font-size:21px;font-weight:700;margin-bottom:1px}.text-muted[data-v-61dd14d0]{font-size:12px;line-height:13px}.outsource-badge[data-v-61dd14d0],.text-cur[data-v-61dd14d0]{font-size:14px;font-weight:400}", ""]);

// exports
